import { StrategyData } from "./StrategyData";

export class StrategyLayoutData {
  constructor(
    public nodes: StrategyData[] = [],
    public childLinks = [],
    public siblingLinks = [],
    public visitorPath = [],
    public width = 0,
    public height = 0,
    public maxY = 0,
    public maxX = 0,
  ) {}
}
